
function headerScrollUp() {
    let InfoBar = document.getElementById("info_bar");
    let heightInfoBar = 0; 
    let header2_0 = document.getElementById("navigation-2_0");

    if (InfoBar != null) {
    heightInfoBar = InfoBar.offsetHeight;
    InfoBar.classList.add("InfoBarFixed");
    InfoBar.style.width = "100%";
    InfoBar.style.zIndex = "1000";
    }
    header2_0.style.marginTop = heightInfoBar + "px";
    header2_0.classList.add("headerFixed");
}

function headerScrollDown() {
    let InfoBar = document.getElementById("info_bar");
    let header2_0 = document.getElementById("navigation-2_0");
    if (InfoBar != null) {
        InfoBar.classList.remove("InfoBarFixed");
        InfoBar.style.width = "100%";
        InfoBar.style.zIndex = "1000";
    }
    header2_0.classList.remove("headerFixed");
    header2_0.style.marginTop = "0px";
}

let lastScrollTop = 0;
    
window.addEventListener("scroll", function () {
    let st = window.pageYOffset || document.documentElement.scrollTop;
    let windowsPosition = $(window).scrollTop();
    let positionLimite = 0;

    if (document.body.classList.contains('template-index')) {
        positionLimite = 110;
    }

    if (windowsPosition > positionLimite) {
        if (st > lastScrollTop) {
            headerScrollDown();
        } else {
            headerScrollUp();
        }
    } else {
        headerScrollDown();
    }
    lastScrollTop = st;
}, false)
